// @flow
const initialState = {
  currentPassword: '',
  password: '',
  confirmPassword: ''
};
export default initialState;